import { User } from 'types/embedded/user';

export const getUserName = (user: User): string => {
  return `${user.firstName} ${user?.lastName}`;
};
